<template>
  <div class="content">
    <div @click.stop="cutEdit">
      <div class="box">
        <div class="box-f">
          <span v-if="!isTestEdit && !istestPreview && !isBankViewTest">{{ question.quesIndex + 1 }}</span>
          <div style="padding: 0px 10px; box-sizing: border-box; width: 80%;" @click="setActiveInput(question.qid)">
            <span v-if="(isBankViewTest || istestPreview) && question.questionsName">{{question.questionsName}}</span>
            <TitleEditor 
              v-if="!isBankViewTest && !istestPreview" 
              class="outline-none" 
              :qid="question.qid" 
              :class="question.qid"  
              :value="question.questionsName" 
              :actionTitleEditorShow="activeInputId === question.qid"
              @childValueChange="val=>{ question.questionsName = val }" 
            ></TitleEditor>
          </div>
            <span class="title-score">（最高分值：{{question.score}}分）</span>
        </div>
        <OperateaWrap 
          v-if="!isTestEdit && !istestPreview" 
          :isBank="isBank"
          :isBankViewTest="isBankViewTest"
          :question="question"
          :bankList="bankList"
          @getBankList="$emit('getBankList')"
          @addToBank="(question, id) => $emit('addToBank', question, id)"
          @addBank="(bankForm, qid) => $emit('addBank', bankForm, qid)"
          @copyQuestion="copyQuestion"
          @delQuestion="delQuestion"
          @delFormBank="(question) => $emit('delFormBank', question)"
        />
      </div>
      <div class="box-c">
        <div v-if="question.questionsTypeId == 209" class="signature">请在此处绘图</div>
        <template v-if="question.questionsTypeId == 210" >
          <el-upload
            disabled
            class="upload-demo"
            action=""
            drag
            multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip">最多{{question.maxfilesNum}}个，单个文件大小不超过{{question.fileSize}}MB</div>
          </el-upload>
          <!-- <div class="upload-file-add">'
            <i></i>
          </div>
          <div class="upload-file-tip"></div> -->
        </template>
        
        <!-- 编辑模态 -->
        <div v-if="question.isedit && !istestPreview && !isBankViewTest" class="option-bottom">
          <el-button type="text" @click="setAnswer">设置答案解析</el-button>
        </div>
      </div>
      <div v-if="question.isedit && !istestPreview && !isBankViewTest" class="subject-warp">
        <h4 class="title-h4">Q{{ question.quesIndex + 1 }}题目设置</h4>
        <div class="subject-box">
          <!-- 左边的 -->
          <ul class="subject-left">
            <li class="subject">
              <span>此题必答</span>
              <div>
                <el-checkbox  v-model="question.mustanswer" ></el-checkbox>
              </div>
            </li>
            <li class="subject">
              <span>隐藏该题目</span>
              <el-switch
                v-model="question.isHideTitle"
                active-color="#1e90ff"
                inactive-color="#ccc"
              >
              </el-switch>
            </li>
            <!-- 需要加判断 -->
            <li class="subject">
              <span>难易度</span>
              <el-select size="mini"
                v-model="question.difficulty"
                :popper-append-to-body="false"
              >
              <el-option
                v-for="item in difficultyList"
                :key="item.difficulty"
                :label="item.label"
                :value="item.value">
              </el-option>
              </el-select>
            </li>
			<li class="subject">
			  <span>标签名称</span>
			 <!-- <el-select multiple collapse-tags v-model="question.quesLabelName" :popper-append-to-body="false" placeholder="请选择">
			     <el-option
			       v-for="item in enumByData"
			       :key="item.value"
			       :label="item.value"
			       :value="item.value">
			     </el-option>
			   </el-select> -->
			    <el-input type="text" style="width: 220px;"  size="mini" placeholder="请输入标签名称" v-model="question.quesLabelName" maxlength="20" show-word-limit></el-input>
			</li>
            <template  v-if="question.questionsTypeId == 210">
              <li class="subject">
                <span>最大上传文件数量</span>
                <el-input-number 
                  v-model="question.maxfilesNum" 
                  
                  size="mini" 
                  :min="1" 
                  :max="10">
                </el-input-number>
              </li>
              <li class="subject">
                <span>单个文件最大限制(MB)</span>
                <el-input-number 
                  v-model="question.fileSize" 
                  
                  size="mini" 
                  :min="1" 
                  :max="30">
                </el-input-number>
              </li>
              <li class="subject">
                <span>文件格式限制</span>
                <el-button @click="formatOptions" type="text">设置</el-button>
              </li>
			  <li class="subject">
			    <span>标签名称</span>
			  <!-- <el-select multiple collapse-tags v-model="question.quesLabelName" :popper-append-to-body="false" placeholder="请选择">
			       <el-option
			         v-for="item in enumByData"
			         :key="item.value"
			         :label="item.value"
			         :value="item.value">
			       </el-option>
			     </el-select> -->
				 <el-input type="text"  style="width: 220px;" size="mini" placeholder="请输入标签名称" v-model="question.quesLabelName" maxlength="20" show-word-limit></el-input>
			  </li>
            </template>
          </ul>
          <!-- 右边的 -->
          <ul class="subject-right">
            <li class="subject subject-none">
              <span>答案与分值</span>
            </li>
            <li class="subject subject-none">
                <span>计分方式</span>
                <el-select  size="mini"
                :popper-append-to-body="false" v-model="question.scoringType" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in scoringTypeList"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </li>
              
            <li class="subject subject-none">
              <span>此题分值</span>
              <PopoverNum
                :value="question.score"
                :size="'mini'"
                :min="1"
                :max="1000"
                :content="'请输入1-1000以内的数值'"
                @valueChange="(val) => question.score = val"
              >
              </PopoverNum>
            </li>
            <!-- <div class="subject-daan">
              答案解析
              <el-input
              v-model="question.analysis"
                placeholder="请输入内容"
                type="textarea"
                size="medium"
                resize="none"
              ></el-input>
            </div> -->
          </ul>
        </div>
      </div>
    </div>
    <!-- 文件格式限制 -->
    <el-dialog
      title="请上传文件"
      :visible.sync="dialogLimitFormat"
      width="50%" :close-on-click-modal="false">
      <div v-for="(item, index) in LimitFormatObj" :key="index">
        <el-checkbox :indeterminate="item.isIndeterminate" v-model="item.checkAll" @change="handleCheckAllChange($event, index)">{{item.title}}</el-checkbox>

        <el-checkbox-group v-model="item.checkedFiles" @change="handleCheckedFilesChange($event, index)">
          <el-checkbox v-for="file in item.files" :label="file" :key="file">{{file}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogLimitFormat = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="filesSubmit">确 定</el-button>
      </span>
    </el-dialog>
    
    <SetAnswerAnalysis 
      v-if="question.isedit && !istestPreview && !isBankViewTest"
      :data="question" 
      @updata="(val) => $emit('updataQuestion', val)"
      ref="setAnswerAnalysis" 
    />
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import PopoverNum from "@/components/myComponents/popoverNum.vue"
import TitleEditor from "@/components/titleEditor/titleEditor.vue"
import OperateaWrap from './operateaWrap/operateaWrap.vue';
import SetAnswerAnalysis from './operateaWrap/setAnswerAnalysis.vue';
export default {
  name: 'QuestionMore',
  
  components:{
    TitleEditor,
    PopoverNum,
    OperateaWrap,
    SetAnswerAnalysis
  },
  props: {
    question: {},
    qindex: { type: Number, default: 0 },
    // 单独的试题编辑（只能编辑当前试题 不能复制以及 移动）
    isTestEdit: {
        type: Boolean,
        default: false
    },
		// 管理题库时查看试题 只可以删除
		isBankViewTest: {
			type: Boolean,
			default: false
		},
    // 单独试题预览 不能对试题进行操作
    istestPreview: {
        type: Boolean,
        default: false
    },
    bankList: {
        type: Array,
        default: () => {
          return []
        }
    },
    // 题库编辑试题，不能显示是否收藏按钮
    isBank: {
        type: Boolean,
        default: false
    },
  },
  data(){
    return {
		enumByData:[],
      dialogLimitFormat:false,
      scoringTypeList: [{
          value: 3,
          label: '人工评分'
        },
      ],
      LimitFormatObj: [
        {
          title: '图片',
          checkAll: false,
          isIndeterminate: false,
          checkedFiles: [],
          files: ['.png','.jpg','.gif','.bmp']
        },
        {
          title: '文档',
          checkAll: false,
          isIndeterminate: false,
          checkedFiles: [],
          files: ['.doc','.docx','.pdf','.xls','.xlsx','.ppt','.pptx','.txt','.sav','.caj']
        },
        {
          title: '压缩文件',
          checkAll: false,
          isIndeterminate: false,
          checkedFiles: [],
          files: ['.rar','.zip','.gzip']
        },
        {
          title: '视频',
          checkAll: false,
          isIndeterminate: false,
          checkedFiles: [],
          files: ['.mp4','.flv','.webm','.mov','.m4v','.wmv','.3gp','.avi']
        },
        {
          title: '视频',
          checkAll: false,
          isIndeterminate: false,
          checkedFiles: [],
          files: ['.mp3','.wma','.wav','.amr','.m4a','.aac']
        },
      ],
      difficultyList: [
        {
          label: '易',
          value: 1
        },
        {
          label: '较易',
          value: 2
        },
        {
          label: '中',
          value: 3
        },
        {
          label: '较难',
          value: 4
        },
        {
          label: '难',
          value: 5
        }
      ],
    }
  },
  computed: {
      ...mapState(['activeInputId']),
  },
  created() {
    if (!this.question.difficulty) {
      this.$set(this.question, 'difficulty', 1)
    }
	  this.queryEnumByType()
  },
  mounted() {
  },
  methods: {
    ...mapActions(['setActiveInput']),
    setAnswer() {
      this.$refs.setAnswerAnalysis.dialogVisible = true
      console.log('设置答案与解析 :>> ');
    },
    queryEnumByType() {
    	let that = this;
    	let params = {
    		that: this,
    		url: `${this.$config.service.queryEnumByType}`,
    		method: 'POST',
    		data: {
    			qid: that.wid,
    			type:'ks',
    			pageSize: 10000,
    			currentPage: 1
    		},
    		cb(res) {
    			// console.log(res);
    			if (res.code == '0') {
    					that.enumByData = res.resultBody.records;
    			} else {
    				that.enumByData =[]
    				that.$message.error(res.message);
    			}
    		}
    	};
    	this.$util.request(params);
    },
    formatOptions() {
      let arr = this.question.limitFormat.split(',')
      this.LimitFormatObj.forEach((info, index) => {
        info.files.forEach((val) => {
          if (arr.indexOf(val) != -1) {
            info.checkedFiles.push(val)
            info.isIndeterminate = true
          }
        })
        
      })
      this.dialogLimitFormat = true
    },
    filesSubmit() {
      let arr = []
      this.LimitFormatObj.forEach((info) => {
        if (info.checkedFiles.length > 0) {
          arr.push(...info.checkedFiles)
        }
      })
      this.question.limitFormat = arr.join(',')
      this.dialogLimitFormat = false
    },
    handleCheckAllChange(val, index) {
      this.LimitFormatObj[index].checkedFiles = val ? this.LimitFormatObj[index].files : [];
      this.LimitFormatObj[index].isIndeterminate = false;
    },
    handleCheckedFilesChange(value, index) {
      let checkedCount = value.length
      this.LimitFormatObj[index].checkAll = checkedCount === this.LimitFormatObj[index].files.length
      this.LimitFormatObj[index].isIndeterminate = checkedCount > 0 && checkedCount < this.LimitFormatObj[index].files.length
    },
    // 编辑选项 动态绑定
    optionBlur(index) {
      this.question.optionList[index].labelName = this.$refs.option[index].innerHTML
    },
    // 点击删除
    delQuestion() {
      // console.log(this.question.qid);
      this.$emit("delQuestion", this.question.qid);
    },
    // 复制当前题目
    copyQuestion(){
      this.$emit("cutEdit");
      this.$emit('copyQuestion', this.question, this.qindex)
    },
    // 点击切换模态框形式
    cutEdit() {
      let state = this.question.isedit
      this.$emit("cutEdit");
      this.question.isedit = true
    },
  },
};
</script>

<style scoped lang="scss">
.to-bank{
  color: #424542;
}
.form-bank{
  /deep/.el-button [class*=" el-icon-"], .el-button [class^="el-icon-"]{
    color: #409EFF;
  }
}
.outline-none{
  // display: inline-block;
  outline: none;
  // max-width: 73%;
  margin-top: 5px;
}
.box {
  display: flex;
  justify-content: space-between;
}
.box-c{
  // margin-bottom: 10px;
  /deep/.el-upload-dragger:hover,/deep/.el-upload-dragger{
    border: 1px dashed #d9d9d9;
    cursor: default;
    background: #f7f8fa;
    line-height: 20px;
  }
  .signature {
    width: 438px;
    height: 190px;
    line-height: 190px;
    text-align: center;
    background: #f7f8fa;
    border: 1px solid #eaeaea;
    font-size: 14px;
    color: #aaa;
    margin: 12px 0 0 37px;
  }
  .upload-file-tip{
    text-align: left;
    font-size: 12px;
    color: #aaa;
    line-height: 18px;
    margin: 12px 0 0 17px;
    width: 400px;
    word-wrap: break-word;
  }
}
.box-f{
  width: 89%;
  font-size: 14px;
  display: flex;
}
.box-f span {
  padding-right: 15px;
}
.title-score{
  color: #ccc;
}
.content{
  background-color: rgb(255, 255, 255);
  line-height: 40px;
  padding: 0 10px;
  margin-bottom: 10px;
  
  .option {
    &-true{
      display: inline-block;
      padding: 0 10px;
      font-size: 14;
      color: #409EFF;
    }
    .quesOptionTitle-box{
      display: flex;
      align-items: center;
      .quesOptionTitle{
        max-width: 80%;
      }
    }
    .circle {
      display: block;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      border: 1px solid #ccc;
      margin-right: 10px;
    }
    .delicon {
      font-size: 16px;
      cursor: pointer;
      margin-left: 20px;
    }
  }
  
  .subject-warp {
    background-color: rgb(255, 255, 255);
    border-top: 1px solid #999;
    font-size: 14px;
    padding-bottom: 20px;

    .title-h4 {
      padding-left: 30px;
    }
    .subject-box {
      display: flex;
      justify-content: space-around;
      line-height: 60px;
      .subject-left{
        // width: 24%;
        right: 338px;
      }
      .subject-right {
        background-color: rgba(242, 242, 242, 1);
        padding: 0 20px 20px 20px;
      }
        .subject {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #999;
          align-items: center;
          .placeholder-input {
            width: 64%;
          }
        }
        // .subject-direction{
        //   display: flex;
        //   flex
        // }
        
        .subject-daan {
          line-height: 30px;
        }
        .subject-none {
          border: none;
          line-height: 50px;
        }
    }
        
  }
  
}
/deep/.el-textarea.is-disabled .el-textarea__inner{
    border: 1px solid #DCDFE6;
    background-color: #FFF;
    width: 400px;
}
.itemCD{
    display: flex;
    flex-direction: column;
}
.itemC{
  display: flex;
  align-items: center;
}
.flex-itemC-none{
  align-items: flex-start !important;
}
/deep/.el-table__header .el-table-column--selection .cell .el-checkbox:after {
  content: " 此空必填";
}

/*在谷歌下移除input[number]的上下箭头*/
.el-input__inner[type="number"]::-webkit-outer-spin-button,
/deep/.el-input__inner[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
}

/*在firefox下移除input[number]的上下箭头*/
.el-input__inner[type="number"] {
    -moz-appearance: textfield;
}
.range-input{
  margin: 0 10px;
}
/deep/.el-dialog {
    width: 860px !important;
}
/deep/.el-dropdown-menu{
  min-width: 220px;
}
</style>